// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";

function updateLinkWidth(param, width) {
  return {
          ariaLabel: param.ariaLabel,
          highlight: param.highlight,
          href: param.href,
          id: param.id,
          label: param.label,
          subLinks: param.subLinks,
          title: param.title,
          width: width
        };
}

function linkToSubLink(param) {
  return {
          highlight: param.highlight,
          href: Belt_Option.getWithDefault(param.href, "#"),
          id: param.id,
          label: param.label
        };
}

var Internal = {
  updateLinkWidth: updateLinkWidth,
  linkToSubLink: linkToSubLink
};

function linkToInternalLink(param, width) {
  return {
          ariaLabel: param.ariaLabel,
          highlight: param.highlight,
          href: param.href,
          id: param.id,
          label: param.label,
          subLinks: param.subLinks,
          title: param.title,
          width: width
        };
}

export {
  Internal ,
  linkToInternalLink ,
}
/* No side effect */
